document.addEventListener('DOMContentLoaded', function() {
  let cartState = {};
  const originalFetch = window.fetch;

  // 1. Backend Data Fetchers
  function getVariantInventory(variantId) {
    const qtyDataEl = document.querySelector('.productVariantsQty');
    if (!qtyDataEl) return null;
    try {
      const qtyData = JSON.parse(qtyDataEl.textContent);
      const variant = qtyData.find(v => v.id === parseInt(variantId));
      return variant ? variant.qty : null;
    } catch(err) {
      return null;
    }
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('input[name="id"], select[name="id"]');
    if (variantInput) return variantInput.value;
    const stickySelect = document.querySelector('.sticky-addcart-opstion');
    if (stickySelect) return stickySelect.value;
    return null;
  }

  function fetchCartState() {
    return originalFetch('/cart.js')
      .then(res => res.clone().json())
      .then(cart => {
        cartState = {};
        if (cart.items) {
           cart.items.forEach(item => {
             cartState[item.variant_id] = item.quantity;
           });
        }

        // Dynamically update header cart counts
        if (typeof cart.item_count !== 'undefined') {
           document.querySelectorAll('.cart-count, .h-count').forEach(el => {
              el.textContent = cart.item_count;
           });
        }
        
        return cartState;
      }).catch(err => {
        console.error("Error fetching cart state:", err);
      });
  }

  // 2. UI Update Functions
  function getAddBtns() {
    return document.querySelectorAll('button[name="add"].product-form__submit');
  }

  function showSoldOut() {
    getAddBtns().forEach(btn => {
       btn.setAttribute('disabled', 'disabled');
       btn.classList.add('disabled');
       
       const span = btn.querySelector('.bls__button-content') || btn.querySelector('span.hidden-loading') || btn.querySelector('span');
       if (span) {
           span.textContent = window.variantStrings ? window.variantStrings.soldOut : 'Sold out';
       }
       btn.style.setProperty('background-color', '#e0e0e0', 'important');
       btn.style.setProperty('color', '#888888', 'important');
       btn.style.setProperty('border-color', '#e0e0e0', 'important');
       btn.style.setProperty('cursor', 'not-allowed', 'important');
       btn.style.setProperty('box-shadow', 'none', 'important');
    });

    // Disable dynamic checkout buttons (Buy Now)
    document.querySelectorAll('.bls__product-dynamic-checkout').forEach(container => {
       container.style.setProperty('position', 'relative', 'important');
       container.style.setProperty('opacity', '0.5', 'important');
       container.style.setProperty('cursor', 'not-allowed', 'important');
       
       if (!container.querySelector('.sold-out-overlay')) {
         const overlay = document.createElement('div');
         overlay.className = 'sold-out-overlay';
         overlay.style.position = 'absolute';
         overlay.style.top = '0';
         overlay.style.left = '0';
         overlay.style.width = '100%';
         overlay.style.height = '100%';
         overlay.style.zIndex = '10';
         overlay.style.cursor = 'not-allowed';
         container.appendChild(overlay);
       }
       
       container.querySelectorAll('button, iframe').forEach(el => {
         el.style.setProperty('pointer-events', 'none', 'important');
       });
    });

    // Enable/Show "Notify Me" button
    document.querySelectorAll('.bls__product-notify').forEach(notify => {
       notify.classList.remove('hidden');
       notify.style.setProperty('display', 'block', 'important');
    });
  }

  function resetSoldOut() {
    getAddBtns().forEach(btn => {
       btn.removeAttribute('disabled');
       btn.classList.remove('disabled');
       
       const span = btn.querySelector('.bls__button-content') || btn.querySelector('span.hidden-loading') || btn.querySelector('span');
       if (span && (span.textContent.trim().toLowerCase() === 'sold out' || span.textContent.trim().toLowerCase() === 'out of stock')) {
           span.textContent = (window.variantStrings && window.variantStrings.addToCart) ? window.variantStrings.addToCart : 'Add to cart';
       }
       
       btn.style.removeProperty('background-color');
       btn.style.removeProperty('color');
       btn.style.removeProperty('border-color');
       btn.style.removeProperty('cursor');
       btn.style.removeProperty('box-shadow');
    });

    // Re-enable dynamic checkout buttons
    document.querySelectorAll('.bls__product-dynamic-checkout').forEach(container => {
       container.style.removeProperty('opacity');
       container.style.removeProperty('cursor');
       const overlay = container.querySelector('.sold-out-overlay');
       if (overlay) overlay.remove();
       
       container.querySelectorAll('button, iframe').forEach(el => {
         el.style.removeProperty('pointer-events');
       });
    });

    // Hide "Notify Me" button
    document.querySelectorAll('.bls__product-notify').forEach(notify => {
       notify.classList.add('hidden');
       notify.style.setProperty('display', 'none', 'important');
    });
  }

  function showToast(message, type) {
     const toast = document.createElement('div');
     toast.className = 'custom-ajax-toast';
     toast.style.position = 'fixed';
     toast.style.bottom = '40px';
     toast.style.left = '50%';
     toast.style.transform = 'translateX(-50%)';
     toast.style.backgroundColor = type === 'error' ? '#D10028' : '#111111';
     toast.style.color = 'white';
     toast.style.padding = '12px 24px';
     toast.style.borderRadius = '5px';
     toast.style.zIndex = '999999';
     toast.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
     toast.style.fontWeight = '500';
     toast.style.fontSize = '14px';
     toast.innerText = message;
     document.body.appendChild(toast);
     setTimeout(() => {
        toast.style.transition = 'opacity 0.5s ease';
        toast.style.opacity = '0';
        setTimeout(() => toast.remove(), 500);
     }, 3000);
  }

  function updateMaxInput(inventory, cartQty) {
    let maxAllowed = inventory - cartQty;
    if (maxAllowed < 0) maxAllowed = 0;

    const qtyInputs = document.querySelectorAll('.quantity__input.product-detail__input, .quantity__input.product-sticky__input');
    qtyInputs.forEach(qtyInput => {
       if (inventory > 0) {
          qtyInput.setAttribute('max', maxAllowed);
          if (parseInt(qtyInput.value) > maxAllowed) {
            qtyInput.value = maxAllowed > 0 ? maxAllowed : 1; 
          }
       } else {
          qtyInput.removeAttribute('max');
       }
    });
  }

  // Custom swatch style for sold out
  if (!document.getElementById('custom-swatch-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-swatch-styles';
    style.textContent = `
      .bls__option-swatch.custom-sold-out-swatch {
        opacity: 0.5;
        position: relative;
      }
      .bls__option-swatch.custom-sold-out-swatch::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to top right, transparent calc(50% - 1px), red calc(50% - 1px), red calc(50% + 1px), transparent calc(50% + 1px));
        z-index: 10;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  }

  function updateSwatchStyles() {
    const variantSelectsEl = document.querySelector('variant-selects script[type="application/json"]');
    const qtyDataEl = document.querySelector('.productVariantsQty');
    if (!variantSelectsEl || !qtyDataEl) return;
    
    try {
      const variantsData = JSON.parse(variantSelectsEl.textContent);
      const qtyData = JSON.parse(qtyDataEl.textContent);
      
      const fieldsets = Array.from(document.querySelectorAll('variant-selects fieldset'));
      if (!fieldsets.length) return;
      
      const currentOptions = fieldsets.map(fs => {
         const activeSwatch = fs.querySelector('.bls__option-swatch.active');
         return activeSwatch ? activeSwatch.getAttribute('data-value') : null;
      });
      
      fieldsets.forEach((fs, optionIndex) => {
         const swatches = fs.querySelectorAll('.bls__option-swatch');
         swatches.forEach(swatch => {
            const value = swatch.getAttribute('data-value');
            const testOptions = [...currentOptions];
            testOptions[optionIndex] = value;
            
            const matchingVariant = variantsData.find(v => {
               return v.option1 === testOptions[0] &&
                      (testOptions.length > 1 ? v.option2 === testOptions[1] : true) &&
                      (testOptions.length > 2 ? v.option3 === testOptions[2] : true);
            });
            
            let isAvailable = false;
            if (matchingVariant) {
               const vQty = qtyData.find(q => q.id === matchingVariant.id);
               // consider cart qty if you want, but for UI swatches base inventory is usually enough
               const cartQty = cartState[matchingVariant.id] || 0;
               if (vQty && (vQty.qty - cartQty) > 0) {
                  isAvailable = true;
               }
            }
            
            if (!isAvailable) {
               swatch.classList.add('custom-sold-out-swatch');
            } else {
               swatch.classList.remove('custom-sold-out-swatch');
            }
         });
      });
    } catch(err) {}
  }

  // 3. Stock Validation Flow
  function validateStockUI() {
    updateSwatchStyles();
    const variantId = getCurrentVariantId();
    if (!variantId) return;
    const inventory = getVariantInventory(variantId);
    if (inventory === null) return; 
    
    const cartQty = cartState[variantId] || 0;
    
    if (inventory > 0) {
      updateMaxInput(inventory, cartQty);
      if (cartQty >= inventory) {
        showSoldOut();
      } else {
        resetSoldOut();
      }
    } else {
      updateMaxInput(0, cartQty);
      showSoldOut();
    }
  }

  // 4. AJAX Fetch Interceptor (Catches 422 Errors and Successes)
  window.fetch = async function() {
    const urlStr = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url ? arguments[0].url : '');
    
    if (urlStr.includes('/cart/add')) {
       try {
         const response = await originalFetch.apply(this, arguments);
         
         if (response.status === 422) {
            // Edge Case: Race condition where another customer purchased it or max reached
            const data = await response.clone().json();
            showSoldOut();
            showToast(data.description || data.message || "Product is sold out.", "error");
            return response;
         } else if (response.ok) {
            // Success! Fetch updated cart state
            fetchCartState().then(() => validateStockUI());
         }
         
         return response;
       } catch (err) {
         return originalFetch.apply(this, arguments);
       }
    }

    // For all other cart mutating requests
    const fetchPromise = originalFetch.apply(this, arguments);
    fetchPromise.then(res => {
      if (urlStr.includes('/cart/change') || urlStr.includes('/cart/update') || urlStr.includes('cart.js') || urlStr.includes('cart.json')) {
         fetchCartState().then(() => validateStockUI());
      }
      return res;
    });
    return fetchPromise;
  };

  // XMLHttpRequest Interceptor (for legacy or third-party cart apps)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('cart.js') || url.includes('cart.json'))) {
         fetchCartState().then(() => validateStockUI());
      }
    });
    origOpen.apply(this, arguments);
  };

  // 5. Initial Page Load Validation
  fetchCartState().then(() => validateStockUI());

  // 6. Handle Variant Changes
  // Many themes update variants via JS without triggering native 'change' events.
  // We'll intercept URL changes (Shopify themes update ?variant= in URL) and swatch clicks.
  function onVariantChange() {
    setTimeout(() => validateStockUI(), 50);
    setTimeout(() => validateStockUI(), 200);
    setTimeout(() => validateStockUI(), 500);
  }

  const originalReplaceState = history.replaceState;
  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    onVariantChange();
  };
  
  const originalPushState = history.pushState;
  history.pushState = function() {
    originalPushState.apply(this, arguments);
    onVariantChange();
  };

  document.addEventListener('click', function(e) {
    if (e.target.closest('.bls__option-swatch') || e.target.closest('variant-selects')) {
      onVariantChange();
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.name === 'id' || e.target.closest('variant-selects')) {
      onVariantChange();
    }
  });

  // 7. Quantity Input Limit Handlers
  document.addEventListener('click', function(e) {
    const plusBtn = e.target.closest('button[name="plus"]');
    if (plusBtn) {
      const wrapper = plusBtn.closest('quantity-input');
      if (!wrapper) return;
      const input = wrapper.querySelector('input[type="number"]');
      if (!input) return;
      const max = input.getAttribute('max');
      if (max && parseInt(input.value) >= parseInt(max, 10)) {
        e.preventDefault();
        e.stopPropagation();
        input.value = max;
        showQuantityError(wrapper, max);
      } else {
        hideQuantityError(wrapper);
      }
    }
  }, true);

  document.addEventListener('change', function(e) {
    const input = e.target;
    if (input.matches('input[type="number"][name="quantity"], input[type="number"][name="updates[]"]')) {
      const max = input.getAttribute('max');
      if (max && parseInt(input.value) > parseInt(max, 10)) {
        input.value = max;
        showQuantityError(input.closest('quantity-input'), max);
      } else {
        hideQuantityError(input.closest('quantity-input'));
      }
    }
  });

  document.addEventListener('input', function(e) {
    const input = e.target;
    if (input.matches('input[type="number"][name="quantity"], input[type="number"][name="updates[]"]')) {
      const max = input.getAttribute('max');
      if (max && parseInt(input.value) > parseInt(max, 10)) {
        input.value = max;
        showQuantityError(input.closest('quantity-input'), max);
      } else {
        hideQuantityError(input.closest('quantity-input'));
      }
    }
  });

  function showQuantityError(wrapper, maxQty) {
    if (!wrapper) return;
    const targetParent = wrapper.closest('.product-form__buttons') || wrapper.parentNode;
    let errorMsg = targetParent.parentNode.querySelector('.quantity-limit-error');
    if (!errorMsg) {
      errorMsg = document.createElement('div');
      errorMsg.className = 'quantity-limit-error error-message mt-5 fs-small color-red';
      errorMsg.style.color = '#D10028';
      errorMsg.style.width = '100%';
      errorMsg.style.textAlign = 'center';
      errorMsg.style.marginTop = '15px';
      errorMsg.style.marginBottom = '15px';
      if (targetParent.nextSibling) {
        targetParent.parentNode.insertBefore(errorMsg, targetParent.nextSibling);
      } else {
        targetParent.parentNode.appendChild(errorMsg);
      }
    }
    
    if (errorMsg.dataset.timeoutId) {
      clearTimeout(parseInt(errorMsg.dataset.timeoutId));
    }

    if (parseInt(maxQty, 10) === 0) {
      errorMsg.innerHTML = "Sorry, this item is no longer available.";
    } else {
      errorMsg.innerHTML = `Only ${maxQty} item${maxQty > 1 ? 's' : ''} left in stock-order now!`;
    }
    
    const timeoutId = setTimeout(() => {
      if (errorMsg && errorMsg.parentNode) {
        errorMsg.remove();
      }
    }, 3500);
    
    errorMsg.dataset.timeoutId = timeoutId.toString();
  }

  function hideQuantityError(wrapper) {
    if (!wrapper) return;
    const targetParent = wrapper.closest('.product-form__buttons') || wrapper.parentNode;
    const errorMsg = targetParent.parentNode.querySelector('.quantity-limit-error');
    if (errorMsg) {
      errorMsg.remove();
    }
  }
});
